import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getReportUserList } from "../../../redux/action/admin/AdminAcountsAction";
import UserReportListItem from "./UserReportListItem";
import EmptyCard from "../../../components/common/EmptyCard";
import InfiniteScroll from "react-infinite-scroll-component";
import ErrorMessage from "../../../components/common/ErrorMessage";
import BubblesLoader from "../../common/BubblesLoader";

const UserReports = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [listError, setListError] = useState("");
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const userReportList = useSelector(
    (state) => state.AdminAcountsReducer.userReportList
  );

  const pageChangeHandler = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    dispatch(getReportUserList(setLoading, page, setHasMore, setListError));
  }, [dispatch, setLoading, page]);

  const userReportListArray =
    page === 0 && loading ? (
      <div className="h-100 d-flex justify-content-center align-items-center flex-column">
        <BubblesLoader />
        <p className="pt-3 common-heading-Medium  f-w-600 text-black md-font">
          Please wait...
        </p>
      </div>
    ) : userReportList && userReportList.length > 0 ? (
      userReportList.map((item, index) => {
        return <UserReportListItem key={index} item={item} loading={loading} />;
      })
    ) : (
      <EmptyCard message={"You’ve not any User Report List Yet!"} />
    );

  return (
    <div className="container-fluid">
      <div className="bg-white box-shadow p-sm-4 p-2  mt-3 br-10 overflow-x-hidden">
        <div className="d-flex flex-sm-row flex-column  justify-content-sm-between align-items-center mt-3">
          <p className="common-heading-Medium xs-font  mb-0">User Reports</p>
        </div>
        <span className="border-bottom d-block pt-3"></span>
        {listError !== "" ? <ErrorMessage message={listError} /> : ""}
        <div className=" mt-4 notification-scroll " id="admin-User-report-list">
          <div className="infinite_scroll h-100">
            <InfiniteScroll
              className={`${
                userReportList.length > 0 && page === 0 && !loading
                  ? ""
                  : "h-100 "
              }`}
              dataLength={userReportList.length}
              next={pageChangeHandler}
              hasMore={hasMore}
              scrollableTarget="admin-User-report-list"
              loader={
                page > 0 && loading ? (
                  <div className="h-100 d-flex justify-content-center align-items-center flex-column">
                    <BubblesLoader />
                  </div>
                ) : (
                  ""
                )
              }
            >
              {userReportListArray}
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserReports;
